import React from 'react'

const RateLimitTitle = () => (
  <div className='portlet-title'>
    <div className='caption'>
      <i className='fa fa-line-chart font-green-haze hidden-xs' />
      <span className='caption-subject bold font-green-haze uppercase'>
        OVERRIDE DEFAULT RATE LIMITS
      </span>
      &nbsp;
      <span className='caption-helper hidden-xs'>
        This will apply to all experiences on this user handle
      </span>
    </div>
  </div>
)

export default RateLimitTitle



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-rate-limits/components/rate-limit-title.js